import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/DataTable/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import QueryDetailModal from "../../components/queries/Query Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import Switch from "react-switch";

export default function Queries() {
  const title = "Query Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showQueryDetailModal, setShowQueryDetailModal] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleReadMore = (id) => {
    setExpandedRow((prev) => (prev === id ? null : id));
  };
  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Name</b>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: <b>Email</b>,
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: <b>Phone Number</b>,
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: <b>Subject</b>,
      cell: (row) => (
        <div
          style={{
            maxWidth: "200px",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          {row.subject}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>Query</b>,
      cell: (row) => {
        const isExpanded = expandedRow === row._id;
        const text = row.query || "";

        const displayText = isExpanded ? text : text.slice(0, 100);

        return (
          <div
            style={{
              maxWidth: "250px",
              overflowWrap: "break-word",
              wordBreak: "break-word",
            }}
          >
            {displayText}
            {text.length > 100 && (
              <button
                onClick={() => toggleReadMore(row._id)}
                className="btn btn-link p-0 ms-1"
                style={{
                  fontSize: "0.85rem",
                  textDecoration: "none",
                  color: "#007bff",
                }}
              >
                {isExpanded ? "Read Less" : "Read More"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },

    {
      name: <b>Created At</b>,
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => viewQuery(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/contacts`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (Array.isArray(response.data.data)) {
        setApiState(response.data.data);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      // setApiCol(columns);
    } catch (error) {
      console.log("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const viewQuery = (query) => {
    setSelectedQuery(query);
    setShowQueryDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((query) => ({
      Name: query.name,
      Email: query.email,
      "Phone Number": query.phone,
      Subject: query.subject,
      Query: query.query,
      "Created At": formatDate(query.createdAt),
      "Updated At": formatDate(query.updatedAt),
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Queries");

    XLSX.writeFile(workbook, "query.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <QueryDetailModal
        show={showQueryDetailModal}
        onHide={() => setShowQueryDetailModal(false)}
        query={selectedQuery}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    apidata={apistate}
                    columns={columns}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
